var SENTRY_RELEASE;SENTRY_RELEASE={name: "Chill Out Cashier", version: "1.0.0"};